import ButtonFavorite from './ButtonFavorite';
export default ButtonFavorite;
